// extracted by mini-css-extract-plugin
module.exports = {"sdzcpiz":"sdzcpiz","disabled":"disabled","selected":"selected"};